
export const REACT_SELECT_LABELS = {
    addLabelText: 'Hozzáadja "{label}"?',
    clearAllText: 'Összes törlése',
    clearValueText: 'Érték törlése',
    noResultsText: 'Nincs találat',
    placeholder: "Válasszon...",
    searchPromptText: 'Gépeljen a kereséshez'
};